import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { UserRecord } from '../../../types';

interface RecentUsersTableProps {
  users: UserRecord[];
  formatDate: (dateStr?: string | null) => string;
}

export function RecentUsersTable({ users, formatDate }: RecentUsersTableProps) {
  const { t } = useTranslation();

  return (
    <div className="admin-chart-section admin-recent-users-section">
      <div className="admin-chart-header">
        <div>
          <h3 className="admin-chart-title">{t('admin.recentUsers')}</h3>
          <p className="admin-chart-subtitle">{t('admin.usersDesc')}</p>
        </div>
      </div>

      <div className="admin-table-responsive recent-users-table-wrap">
        {users.length === 0 ? (
          <div className="admin-table-empty">
            {t('admin.noRecentUsers')}
          </div>
        ) : (
          <>
            <table className="admin-table table-fit">
              <thead>
                <tr>
                  <th>{t('admin.userName')}</th>
                  <th>{t('admin.userEmail')}</th>
                  <th>{t('admin.userRole')}</th>
                  <th>{t('admin.userJoined')}</th>
                </tr>
              </thead>
              <tbody>
                {users.map((u) => (
                  <tr key={u.id}>
                    <td>
                      <div className="admin-user-cell">
                        <span className="admin-user-avatar">{u.name?.charAt(0).toUpperCase()}</span>
                        <span className="admin-user-name">{u.name}</span>
                      </div>
                    </td>
                    <td>{u.email}</td>
                    <td>
                      <span className={`admin-role-badge role-${u.role.toLowerCase()}`}>{u.role}</span>
                    </td>
                    <td>{formatDate(u.createdAt)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            
            <div className="admin-recent-users-footer">
              <Link to="/admin/users" className="admin-view-all-link">
                {t('admin.viewAllUsers')}
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
